<template>
    <div>
        <rkm-area
            v-if="item"
            type="fieldset"
            title="Transporte atual"
        >
            <rkm-form ref="Form">
                <rkm-row>

                    <rkm-col cols="6">
                        <rkm-form-input
                            label="Motorista"
                            v-model="item.motoristaNome"
                            disabled
                        />
                    </rkm-col>

                    <rkm-col cols="6">
                        <rkm-form-input
                            label="Veículo"
                            v-model="item.veiculoNome"
                            disabled
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>

                    <rkm-col cols="6">
                        <rkm-form-input
                            label="Diária"
                            v-model="item.diaria"
                            v-money="money"
                            prepend="R$"
                            disabled
                        />
                    </rkm-col>

                    <rkm-col cols="6">
                        <rkm-form-input
                            label="Jornada"
                            v-model="item.jornada"
                            disabled
                        />
                    </rkm-col>
                </rkm-row>
            </rkm-form>
        </rkm-area>

        <rkm-area
            v-if="items.length > 0"
            title="ATRIBUIR PARA OS AGENDAMENTOS SELECIONADOS"
            type="fieldset"
            no-margin-top
        >

            <rkm-form ref="FormAtribuir">
                <rkm-row class="flex-nowrap">

                    <rkm-col :cols="agendarTransporteJornada ? '3' : '4'">
                        <rkm-form-select
                            :options="motoristas"
                            text-field="nome"
                            value-field="id"
                            label="Motorista"
                            v-model="model.motoristaId"
                            :validations="validations.motorista"
                            show-default-option
                            @change="loadFields('motoristaId')"
                        />
                    </rkm-col>

                    <rkm-col :cols="agendarTransporteJornada ? '3' : '4'">
                        <rkm-form-select
                            :options="veiculos"
                            text-field="descricao"
                            value-field="id"
                            label="Veículo"
                            v-model="model.veiculoId"
                            :validations="validations.veiculo"
                            show-default-option
                            :default-option-text="veiculos.length === 0 ? 'Nenhum veículo para o motorista' : 'Selecione'"
                            :disabled="veiculos.length === 0"
                            @change="handleVeiculo()"
                        />
                    </rkm-col>

                    <rkm-col cols="4"
                        v-if="agendarTransporteJornada"
                    >
                        <rkm-form-select
                            :options="jornadas"
                            text-field="descricao"
                            value-field="id"
                            label="Jornada"
                            v-model="model.jornadaId"
                            :disabled="!model.veiculoId"
                            :validations="model.veiculoId ? validations.jornada : {}"
                            show-default-option
                            @change="handleJornada()"
                        />
                    </rkm-col>

                    <rkm-col :cols="agendarTransporteJornada ? '2' : '4'">
                        <rkm-form-input
                            label="Diária"
                            ref="novaDiaria"
                            v-model="model.novaDiaria"
                            v-money="money"
                            prepend="R$"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row class="flex-nowrap">

                    <rkm-col cols="1">
                        <rkm-form-input
                            label="Agendados"
                            type="number"
                            v-model="getTotalAgendados"
                            disabled
                        />
                    </rkm-col>

                    <rkm-col cols="1">
                        <rkm-form-input
                            label="Capacidade"
                            type="number"
                            v-model="model.capacidade"
                            disabled
                        />
                    </rkm-col>

                    <rkm-col cols="2">
                        <rkm-form-select
                            :options="tiposVeiculo"
                            text-field="descricao"
                            value-field="id"
                            label="Tipo de veículo"
                            v-model="model.tipoVeiculoId"
                            show-default-option
                            disabled
                        />
                    </rkm-col>

                    <rkm-col>
                        <rkm-form-input
                            label="Protocolo"
                            v-model="model.protocolo"
                            disabled
                        />
                    </rkm-col>

                    <rkm-col cols="2">
                        <rkm-form-input
                            label="Passageiros selecionados"
                            type="number"
                            v-model="getTotalSelecionado"
                            disabled
                        />
                    </rkm-col>

                    <rkm-col cols="2">
                        <rkm-form-input
                            label="Vagas disponíveis"
                            type="number"
                            v-model="getVagasDisponiveis"
                            disabled
                        />
                    </rkm-col>

                    <rkm-col cols="auto">

                        <rkm-button
                            :label="false"
                            @click="$refs.FormAtribuir.validate(atribuir)"
                            color="primary"
                            :disabled="handleDisabledAtribuir"
                        >
                            Atribuir
                        </rkm-button>

                        <rkm-button
                            :label="false"
                            @click.stop="resetAtribuir"
                            color="secondary"
                            :disabled="!model.veiculoId || !model.motoristaId"
                        >
                            Limpar
                        </rkm-button>
                    </rkm-col>
                </rkm-row>
            </rkm-form>
        </rkm-area>

        <rkm-row v-if="items.length > 0">
            <rkm-col>
                <rkm-button
                    @click="selecionarTodos()"
                    color="primary"
                    class="mb-2"
                >
                    <template v-if="selecionados == false">
                        Selecionar todos
                    </template>

                    <template v-else>
                        Desmarcar selecionado(s)
                    </template>
                </rkm-button>

                <template>
                    <rkm-button
                        v-if="selecionados == true"
                        @click="cancelAtribuirSelecionados()"
                        :disabled="handleDisabledAtribuidos"
                        color="danger"
                        class="mb-2"
                    >
                        Cancelar atruibuição dos selecionado(s)
                    </rkm-button>
                </template>
            </rkm-col>
        </rkm-row>

        <rkm-table
            :items="items"
            :fields="fields"
            hide-filters
            hide-pagination
            sort-by="pacienteNome"
        >

            <template v-slot:cell(checkbox)="{ item }">
                <rkm-form-checkbox
                    v-model="item.selecionado"
                    @change="handleBlur()"
                />
            </template>

            <template v-slot:cell(diaria)="{ item }">
                {{ item.diaria === null ? '-' : `R$ ${item.diaria}` }}
            </template>

            <template v-slot:cell(pacienteNome)="{ item }">

                <rkm-button
                    class="mr-2"
                    color="secondary"
                    small
                    v-rkm-popover.hover.top="
                        {
                            title: 'Dados cadastrais',
                            html: true,
                            content:
                                '<b>Prontuário:</b> ' + (item.prontuario || '') + '<br/>' +
                                '<b>Data de Nascimento:</b> ' + item.dataNascimento + '<br/>' +
                                '<b>Nome da Mãe:</b> ' + item.nomeMae + '<br/>'
                        }
                    "
                >
                    <rkm-icon icon="user" />
                </rkm-button>

                {{ item.pacienteNome }}

                <template v-if="item.pacienteNomeSocial">
                    <template v-if="item.pacientePreferenciaNomeId === enums.preferenciaNome.NOME_SOCIAL">
                        <strong>({{ item.pacienteNomeSocial }})</strong>
                    </template>

                    <template v-else>
                        ({{ item.pacienteNomeSocial }})
                    </template>
                </template>
            </template>

            <template v-slot:cell(actions)="{ item }">

                <rkm-button
                    :color="item.observacao ? 'info' : 'secondary'"
                    small
                    v-rkm-popover.hover.left="{
                        title:'Observação',
                        html:true,
                        content: item.observacao ? item.observacao : 'Nenhuma observação informada.',
                        }"
                >
                    <i class="fas fa-comment-alt"></i>
                </rkm-button>

                <rkm-button
                    title="Cancelar atribuição"
                    color="danger"
                    :disabled="!item.atribuido"
                    @click="cancelAtribuir(item)"
                    small
                >
                    <rkm-icon icon="trash" />
                </rkm-button>
            </template>
        </rkm-table>

        <ModalPermissao
            ref="RkmModalPermissao"
            @handlePermission="handlePermission"
        />
    </div>
</template>

<script>

// Vuex.
import { mapActions } from 'vuex'

//Directives
import { VMoney } from 'v-money'

// Mixins.
import { error, repository, object, data, stringCase} from '@/mixins'

// Filters.
import format from '@/filters/formats'

// Moment.
import moment from 'moment'

// Enums.
import preferenciaNome from '@/enums/cadastro/cidadao/preferenciaNome'

// Components.
import ModalPermissao from '@/components/transporte-paciente/transferencia/permissao/Modal'

export default {
    components: {
        ModalPermissao
    },
    directives: { money: VMoney },
    computed: {
        validations() {

            return {
                dataSaida: { required: true },
                municipio: { required: true },
                veiculo: { required: true },
                jornada: { required: true },
                motorista: { required: true },
            }
        },
        validationsHorarioSaida() {

            return (item) => {
                return {
                    max_hour: item.dataConsulta === item.dataSaida ? this.getMaxHour(item) : false
                };
            };
        },
        getTotalSelecionado() {

            return this.items.filter(item => item.selecionado)
                .reduce((sum, element) => {

                    if (this.agendarTransporteJornada) {

                        if (element.jornadaId !== this.model.jornadaId && element.jornadaId !== null || element.jornadaId == null) {

                            if (element.acompanhante !== 'NÃO') {

                                sum = sum + (Number(element.acompanhante) + 1);
                            } else {

                                sum++;
                            }
                        }
                    } else {

                        if (element.veiculoId !== this.model.veiculoId) {

                            if (element.acompanhante !== 'NÃO') {

                                sum = sum + (Number(element.acompanhante) + 1);
                            } else {

                                sum++;
                            }
                        }
                    }

                    return sum;
                },0)
        },
        getTotalAgendados() {

            const total = this.item.veiculoId === this.model.veiculoId
                && this.item.motoristaId === this.model.motoristaId ? 0 : this.model.totalAgendados

            let atribuidos = 0
            if(this.agendarTransporteJornada) {
                atribuidos = this.items.filter(item => item.jornadaId === this.model.jornadaId)
                    .reduce((sum, element) => (element.acompanhante !== 'NÃO' ? sum + (Number(element.acompanhante) + 1) : sum++), 0)
            } else {
                atribuidos = this.items.filter(item => item.veiculoId === this.model.veiculoId && item.motoristaId === this.model.motoristaId)
                    .reduce((sum, element) => {

                        if (element.acompanhante !== 'NÃO') {

                            sum = sum + (Number(element.acompanhante) + 1);
                        } else {

                            sum++;
                        }

                        return sum;
                    },0)
            }

            return this.model.veiculoId && atribuidos > 0 ? Number(total) + Number(atribuidos) : total
        },
        getVagasDisponiveis() {

            const vagas = this.model.capacidade - this.getTotalAgendados >= 0
                ? this.model.capacidade - this.getTotalAgendados
                : 0

            return this.model.veiculoId ? vagas : null
        },
        handleDisabledAtribuidos() {

            const atribuidos = this.items.filter(item => item.selecionado && item.atribuido)

            return atribuidos.length === 0 ? true : false
        },
        handleDisabledAtribuir() {

            const atribuidos = this.items.filter(item =>
                item.selecionado
            )

            return atribuidos.length === 0 || this.model.veiculoId == null ? true : false
        },
        fields() {
            const fields = [
                {
                    key: 'checkbox',
                    label: '#',
                    class: 'col-min text-center',
                },
                {
                    key: 'pacienteNome',
                    label: 'Paciente',
                    searchable: true,
                    sortable: true,
                },
                {
                    key: 'municipio',
                    label: 'Município',
                    searchable: true,
                    sortable: true,
                },
                {
                    key: 'destino',
                    label: 'Local da consulta',
                    searchable: true,
                    sortable: true,
                },
                {
                    key: 'dataConsulta',
                    label: 'Data consulta',
                    searchable: true,
                    sortable: true,
                    class: 'col-min text-center',
                },
                {
                    key: 'horarioConsulta',
                    label: 'Horário consulta',
                    searchable: true,
                    sortable: true,
                    class: 'col-min text-center',
                },
                {
                    key: 'acompanhante',
                    label: 'Acompanhante',
                    searchable: true,
                    sortable: true,
                    class: 'col-min text-center',
                },
                {
                    key: 'motoristaNome',
                    label: 'Motorista',
                    searchable: true,
                    sortable: true,
                },
                {
                    key: 'veiculoNome',
                    label: 'Veículo',
                    searchable: true,
                    sortable: true,
                },
                {
                    key: 'protocolo',
                    label: 'Protocolo'
                },
                {
                    key: 'jornada',
                    label: 'Jornada',
                    searchable: true,
                    sortable: true
                },
                {
                    key: 'actions',
                    label: 'Ações',
                    class: 'col-min text-center'
                }
            ]

            return fields
        },
    },
    created() {

        this.repositories = {
            transferencia: this.getConectaSusRepository('transportePaciente.transferencia'),
            agendar: this.getConectaSusRepository('transportePaciente.agendar')
        }

        this.load()
    },
    data: () => ({
        form: [],
        items: [],
        filterDefault: {},
        model: {
            dataSaida: null,
            municipioId: null,
            destinoId: null,
            horarioSaida: null,
            veiculoId: null,
            capacidade: null,
            totalAgendados: null,
            tipoVeiculoId: null,
            protocolo: null,
            tipoPassageiroId: null,
            supervisorId: null,
            motoristaId: null,
            jornadaId: null
        },
        motoristas: [],
        municipios: [],
        destinos: [],
        jornadas: [],
        tiposVeiculo: [],
        agendamentosJornada: [],
        horariosSaida: [],
        veiculos: [],
        tiposPassageiro: [],
        fieldMap: [
            'motoristaId',
            'veiculoId',
            'jornadaId',
            'novaDiaria',
        ],
        isSearch: false,
        agendarTransporteJornada: null,
        selecionados: false,
        enums: {
            preferenciaNome,
        },
        money: {
            decimal: ',',
            thousands: '.',
            prefix: '',
            suffix: '',
            precision: 2,
            masked: false
        }
    }),
    filters: {
        ...format,
    },
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {

            if (this.item == null) {

                this.$emit('handleSave')
            } else {

                this.setLoading()

                this.repositories.transferencia.index(this.getSearchParams())
                    .then(({ data }) => {

                        this.filterDefault = {
                            items: this.clone(data.agendamentos),
                        }

                        if (this.item.jornadaId) {

                            this.items = data.agendamentos.filter(agendamento => agendamento.jornadaId == this.item.jornadaId || agendamento.jornadaId == null)
                        } else {

                            this.items = data.agendamentos
                        }

                        this.motoristas = data.motoristas
                        this.veiculos = data.veiculos
                        this.tiposVeiculo = data.tiposVeiculo
                        this.agendarTransporteJornada = data.agendarTransporteJornada
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
            }
        },
        loadFields(field) {

            this.setLoading()

            this.setFields(field)

            this.repositories.transferencia.loadFields(this.getSearchParams())
                .then(({ data }) => {

                    this.jornadas = data.form.jornadas
                    this.veiculos = data.form.veiculos
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        atribuir() {

            this.$refs.FormAtribuir.validate()
                .then(valid => {

                    if (!valid) return

                        let msg = ''

                        if (!this.validateAtribuir()) {
                            return
                        }

                        this.items.map((item) => {

                            if (item.selecionado) {

                                if (this.agendarTransporteJornada) {

                                    const existeJornada = this.checkJornada(item, msg)

                                    if (existeJornada.existeJornada) {

                                        msg = existeJornada.msg

                                        this.mensagemConflito(msg);
                                        return;
                                    }

                                    item.jornadaId = this.model.jornadaId
                                    item.jornada = this.jornadas.find(jornada =>
                                        jornada.id === this.model.jornadaId).descricao
                                } else {

                                    item.jornadaId = null
                                    item.jornada = 'SEM JORNADA'
                                }

                                if (this.agendarTransporteJornada) {

                                    const viagemId = this.jornadas.find(jornada =>
                                        jornada.id === this.model.jornadaId).viagemId

                                    if (viagemId) {
                                        item.viagemId = viagemId
                                    } else {
                                        item.viagemId = this.veiculos.find(veiculo =>
                                            veiculo.id === this.model.veiculoId).viagemId
                                    }
                                } else {
                                    item.viagemId = this.veiculos.find(veiculo =>
                                        veiculo.id === this.model.veiculoId).viagemId
                                }

                                item.veiculoId = this.model.veiculoId
                                item.diaria = this.model.novaDiaria
                                item.veiculoNome = this.veiculos.find(veiculo => veiculo.id === this.model.veiculoId).descricao
                                if(this.agendarTransporteJornada) {
                                    item.protocolo = this.jornadas.find(jornada => jornada.id === this.model.jornadaId).protocolo
                                }
                                else {
                                    item.protocolo = this.veiculos.find(veiculo => veiculo.id === this.model.veiculoId).protocolo
                                }
                                item.motoristaId = this.model.motoristaId
                                item.motoristaNome = this.motoristas.find(motorista => motorista.id === this.model.motoristaId).nome
                                item.supervisorId = this.model.supervisorId
                                item.totalAgendados = this.getTotalAgendados
                                item.capacidade = this.model.capacidade
                                item.atribuido = true
                            }
                        })

                        this.mensagemConflito(msg)
                        this.resetAtribuir()
                })
        },
        getSearchParams() {

            const params = this.clone(this.item)

            params.motoristaId = this.model.motoristaId

            params.dataSaida = moment(params.dataSaida, 'DD/MM/YYYY').format('YYYY-MM-DD')

            return this.camelObjectKeysToSnakeRecursive(params)
        },
        addWatchers() {

            this.$watch('model.dataSaida', function (data) {

                if (data) {

                    this.loadFields('data')
                }
            })
        },
        setFields(value) {

            this.isSearch = false

            const index = this.fieldMap.indexOf(value) + 1;

            for (let i = index; i < this.fieldMap.length; i++) {

                const field = this.fieldMap[i];

                if (this.model[field] !== null) {

                    for (const ref of Object.values(this.$refs)) {

                        if (ref.validate) {
                            ref.resetValidator();
                        }
                    }

                    this.$set(this.model, field, null);
                }
            }
        },
        resetForm() {

            this.selecionados = false
            this.items = []

            if (this.$refs.Form) {

                this.$refs.Form.resetValidator()
            }
        },
        search() {

            this.setLoading()

            this.repositories.transferencia.list(this.getSearchParams())
                .then(({ data }) => {

                    this.items = data.agendamentos
                    this.agendamentosJornada = data.agendamentosJornada
                    this.veiculos = data.veiculos
                    this.isSearch = true
                    this.selecionados = false

                    this.model.veiculoId = null
                    this.resetAtribuir()
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        getMaxHour(item) {

            const horario = item.horarioConsulta

            if (horario) {

                return moment(horario, 'HH:mm').subtract(1, 'minutes').format('HH:mm')
            }

            return false
        },
        selecionarTodos(){

            if(this.selecionados == false){

                this.selecionados = true
                this.items.map(item => (item.selecionado = true))
            } else {

                this.selecionados = false
                this.items.map(item => (item.selecionado = false))
            }
        },
        showVeiculo() {

            return this.agendarTransporteJornada && this.model.jornadaId
                || !this.agendarTransporteJornada && this.model.veiculoId
        },
        handleVeiculo() {

            if (this.agendarTransporteJornada) {

                this.getJornadas()
            } else if (this.model.veiculoId !== null) {

                const veiculo = this.veiculos.find(v => v.id === this.model.veiculoId)

                this.model.capacidade = veiculo.capacidade
                this.model.totalAgendados = veiculo.agendados ? veiculo.agendados.quantidade : 0
                this.model.tipoVeiculoId = veiculo.tipoId
                this.model.protocolo = veiculo.protocolo
                this.model.novaDiaria = veiculo.diaria

                this.$refs.novaDiaria.$el.getElementsByTagName('input')[0].value = veiculo.diaria
            } else {

                this.resetAtribuir()
            }
        },
        getJornadas() {

            if (this.model.veiculoId) {

                this.setLoading()

                const dataSaida = this.item.dataSaida

                this.repositories.transferencia.getJornadas({
                    'veiculo_id': this.model.veiculoId,
                    'data_saida': `${moment(dataSaida, 'DD/MM/YYYY').format('YYYY-MM-DD')}`,
                })
                    .then(({ data }) => {

                        if (data.length == 0) {

                            this.showAlert('Não existe jornada para o veículo selecionado.', 'Atenção')
                        }

                        this.jornadas = data
                        this.model.jornadaId = null
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            }
        },
        handleJornada() {

            if (this.model.jornadaId) {

                const jornada = this.jornadas.find(jornada => jornada.id === this.model.jornadaId)

                this.model.capacidade = jornada.numeroCapacidade
                this.model.totalAgendados = jornada.totalAgendados
                this.model.tipoVeiculoId = jornada.tipoId
                this.model.protocolo = jornada.protocolo
            }
        },
        checkJornada(item, msg) {

            let existeJornada = false

            if (this.agendarTransporteJornada) {

                const jornada = this.agendamentosJornada.find(jornada => jornada.jornadaId === this.model.jornadaId
                    && jornada.pacienteId === item.pacienteId)

                if (jornada) {

                    existeJornada = true

                    msg = msg.concat('<br/><br/>', `O paciente <strong>${jornada.pacienteNome}</strong> já está agendado
                        nesta jornada (mesmo veículo e horário), portanto não é necessário cadastrá-lo novamente.`)
                }
            }

            if (item.horarioSaida) {

                const dataHoraSaida = moment(this.item.dataSaida, 'DD/MM/YYYY').format('YYYY-MM-DD') + ' ' + item.horarioSaida

                if (dataHoraSaida && !existeJornada) {

                    const horarioSaida = this.agendamentosJornada.find(jornada =>
                        jornada.dataInicial <= dataHoraSaida
                        && jornada.dataFinal >= dataHoraSaida
                        && jornada.pacienteId === item.pacienteId
                    )

                    if (horarioSaida) {

                        existeJornada = true

                        msg = msg.concat('<br/><br/>', `O paciente <strong>${horarioSaida.pacienteNome}</strong> já está
                            agendado em outra jornada (no veículo <strong>${horarioSaida.numeroPlaca}</strong>
                            - <strong>${horarioSaida.descricaoModelo}</strong> no mesmo horário). Para agendá-lo será
                            necessário cancelar o outro agendamento.`)
                    }
                }

                if (dataHoraSaida && !existeJornada) {

                    const horarioSaida = this.jornadas.find(jornada => jornada.id === this.model.jornadaId)

                    if (horarioSaida && !moment(dataHoraSaida).isSameOrAfter(horarioSaida.dataInicial) && !moment(dataHoraSaida).isSameOrBefore(horarioSaida.dataFinal)) {

                        existeJornada = true

                        msg = msg.concat('<br/><br/>', `O atendimento marcado para o dia <strong>${item.dataConsulta} às ${item.horarioConsulta}</strong>
                            do paciente <strong>${item.pacienteNome}</strong> apresenta um conflito de horário com a jornada selecionada.`)
                    }
                }
            } else {

                const dataHoraConsulta = moment(this.item.dataConsulta, 'DD/MM/YYYY').format('YYYY-MM-DD') + ' ' + item.horarioConsulta
                const horarioSaida = this.jornadas.find(jornada => jornada.id === this.model.jornadaId)

                if (horarioSaida && !moment(dataHoraConsulta).isSameOrAfter(horarioSaida.dataInicial) && !moment(dataHoraConsulta).isSameOrBefore(horarioSaida.dataFinal)) {

                    existeJornada = true

                    msg = msg.concat('<br/><br/>', `O atendimento marcado para o dia <strong>${item.dataConsulta} às ${item.horarioConsulta}</strong>
                            do paciente <strong>${item.pacienteNome}</strong> apresenta um conflito de horário com a jornada selecionada.`)
                }
            }

            return {
                msg: msg,
                existeJornada: existeJornada,
            }
        },
        handleBlur(){

            let selecionado = false

            this.items.map(item => {

                if (item.selecionado == true) {

                    selecionado = true
                }
            })

            if (selecionado) {

                this.selecionados = true
            } else {

                this.selecionados = false
            }
        },

        mensagemConflito(msg){

            if(msg){

                this.showAlert('Não foi possível atribuir para o(s) seguinte(s) paciente(s): '  + msg)
            }
        },
        save() {

            this.setLoading()

            this.repositories.transferencia.store(this.camelObjectKeysToSnakeRecursive(this.items))
                .then(() => {

                    this.showSaveNotification(),
                    this.resetForm()

                    this.$emit('handleSave')
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        validateAtribuir() {

            if (this.jornadas && this.jornadas.length === 0 && this.agendarTransporteJornada) {

                this.showAlert('Informe uma data e horário de saída que tenha uma jornada associada.', 'Atenção')

                return false
            }

            const totalAgendados = Number(this.getTotalAgendados) + Number(this.getTotalSelecionado)

            if (this.model.veiculoId && totalAgendados > this.model.capacidade && this.model.supervisorId == null) {

                const msg = `Para continuar com a atribuição, é necessário que sejam informados os dados
                    do supervisor, uma vez que a quantidade de passageiros selecionados excede a capacidade máxima do veículo.
                    Deseja continuar?`

                this.showAlert(msg, 'Atenção')

                const confirm = async () => {

                    this.$refs.RkmModalPermissao.open()
                }

                this.showConfirmation(msg, confirm)

                return false
            }

            return true
        },
        handlePermission(supervisorId){

            this.model.supervisorId = supervisorId

            this.atribuir()
        },
        getTotal() {

            return this.items.reduce((sum, element) => {

                if (element.acompanhante !== 'NÃO') {

                    sum = sum + (Number(element.acompanhante) + 1);
                } else {

                    sum++;
                }

                return sum;
            },0)
        },
        resetAtribuir() {

            this.model.motoristaId = null
            this.model.veiculoId = null
            this.model.novaDiaria = null
            this.model.jornadaId = null
            this.model.capacidade = null
            this.model.totalAgendados = null
            this.model.tipoVeiculoId = null
            this.model.protocolo = null
            this.model.supervisorId = null

            this.$refs.novaDiaria.$el.getElementsByTagName('input')[0].value = ''

            if (this.$refs.FormAtribuir) {

                this.$refs.FormAtribuir.resetValidator()
            }
        },
        cancelAtribuir(item) {

            const viagem = this.filterDefault.items.find(viagem => viagem.id === item.id)

            const cancel = async () => {

                item.veiculoId = viagem.veiculoId
                item.veiculoNome = viagem.veiculoNome
                item.protocolo = viagem.protocolo
                item.motoristaId = viagem.motoristaId
                item.motoristaNome = viagem.motoristaNome
                item.diaria = viagem.diaria
            }

            this.showDeleteConfirmation(`Deseja realmente cancelar a atribuição?`, cancel)
        },
        cancelAtribuirSelecionados() {

            const cancel = async () => this.items.filter(item => item.selecionado && item.veiculoId).map((item) => {

                const viagem = this.filterDefault.items.find(viagem => viagem.id === item.id)

                item.veiculoId = viagem.veiculoId
                item.veiculoNome = viagem.veiculoNome
                item.protocolo = viagem.protocolo
                item.motoristaId = viagem.motoristaId
                item.motoristaNome = viagem.motoristaNome
                item.diaria = viagem.diaria
            })

            this.showDeleteConfirmation(`Deseja realmente cancelar as atribuições selecionadas?`, cancel)
        },
        handleDisabledCheckbox(item) {

            if (this.agendarTransporteJornada) {

                return item.veiculoId == this.model.veiculoId
                    && item.motoristaId == this.model.motoristaId
                    && item.jornadaId == this.model.jornadaId

            } else {
                return item.veiculoId == this.model.veiculoId && item.motoristaId == this.model.motoristaId
            }
        }
    },
    mixins: [ error, repository, object, data, stringCase ],
    props: {
        item: { type: Object, Default: null }
    },
};

</script>

<style scoped>
.dataSaida { width:150px }
.table-td {
    background: #f1f1f1;
    padding: 0 10px;
    height: 35px;
    line-height: 35px;
    font-weight: 600;
}
</style>